/**
 * Horizontal proportion bar used to render risk-level distribution rows
 * (High / Medium / Low / Not Assessed) in dashboard cards. Pairs a label
 * + percent + count header with a fixed-height bar coloured by `barClass`.
 *
 * Consumed by ExecutiveDashboard, SafetyManagerDashboard, and
 * SupervisorDashboard risk-distribution widgets.
 *
 * The bar width applies a small floor (2%) for any non-zero pct so a
 * single DSR in a category remains visible at the leftmost edge.
 */
export interface RiskBarProps {
  label: string;
  pct: number;
  count: number;
  barClass: string;
}

export function RiskBar({ label, pct, count, barClass }: RiskBarProps) {
  return (
    <div className="text-xs">
      <div className="mb-1 flex items-center justify-between">
        <span className="font-medium">{label}</span>
        <span className="text-muted-foreground">
          {pct}% <span className="ml-1">({count})</span>
        </span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded bg-muted">
        <div
          className={`h-full ${barClass}`}
          style={{ width: `${Math.min(100, Math.max(pct, pct > 0 ? 2 : 0))}%` }}
        />
      </div>
    </div>
  );
}
